import client from './client';
import qs from 'qs';

/**
 * 카테고리관리 내 리스트를 가져온다.
 */
export const getCategoryList = (param) =>
  client.get(`/api/manage/category/list`, { params: param });

/**
 * 캠페인 카테고리 리스트를 가져온다.
 */
export const getCampaignCategoryList = () =>
  client.get(`/api/manage/category/campaign`);

/**
 * 캠페인 카테고리 리스트를 가져온다.
 */
export const getOpenrtbCategoryList = () =>
  client.get(`/api/manage/category/openrtb`);

/**
 * 캠페인 카테고리 리스트를 가져온다.
 */
export const getGoogleCategoryList = () =>
  client.get(`/api/manage/category/google`);

/**
 * 카테고리 수정
 * @param {array}
 */
export const addCategory = (params) =>
  client.post(`/api/manage/category/set`, qs.stringify(params));

/**
 * 카테고리 수정
 * @param {array}
 */
export const modifySeqCategory = (params) =>
  client.post(`/api/manage/category/modify`, qs.stringify(params));

/**
 * 카테고리 삭제
 */
export const deleteCategory = (param) =>
  client.delete(`/api/manage/category/delete`, { data: param });

/**
 * 카테고리 이동
 * @param {array}
 */
export const moveCategory = (params) =>
  client.post(`/api/manage/category/move`, qs.stringify(params));

/**
 *  선택된 맵핑 호출
 * @param {array}
 */
export const mappingItem = (param) =>
  client.get(`/api/manage/category/mapping/item`, { params: param });

/**
 * 카테고리 맵핑 저장
 * @param {array}
 */
export const categoryMappingSave = (params) =>
  client.post(`/api/manage/category/mapping/set`, qs.stringify(params));
